
import React, { useState } from 'react';
import './Navbar.css';
import logo from './images/logo-cyber.png';
import img1 from './images/Instagram1.png';
import img2 from './images/Facebook .png';
import img3 from './images/x twitter .png';
import img6 from './images/linkdin1.png';
import img4 from './images/Google1.png';
import img5 from './images/youtube.png';
import menu from './images/menu1.png';
import { Link } from 'react-router-dom';

const Navbar = () => {

  const [menuOpen, setMenuOpen] = useState(false);
  const [courseOpen, setCourseOpen] = useState(false);

  //  MENU CLOSE FUNCTION
  const handleCloseMenu = () => {
    setMenuOpen(false);
    setCourseOpen(false);
  };

  return (
    <>
      <div className='navbar'>

        <div className='nav-left'>
          <Link to="/">
            <img src={logo} alt='' />
          </Link>
        </div>

        <div className='nav-mid'>
          <ul>
            <li><Link to="/AboutPage">About Us</Link></li>

            <div className="navdrop">
              <div className="dropdown">  
                <li><Link to="/CoursesFile" className="dropbtn">Courses</Link></li>
                <div className="dropdown-content">
                  {/* <a href="/CiscoPage">Cisco Certificate</a>
                  <a href="/CCNAPage">CCNA</a>
                  <a href="/EthicalPage">Ethical Hacking</a>
                  <a href="/LinuxPage">Linux</a>
                  <a href="/BasicCyberPage">Certificate in Cyber Security</a>
                  <a href="/AdvanceCyberPage">Advanced Cyber Security</a> */}
<Link to="/CiscoPage">Cisco Certificate</Link>
<Link to="/CCNAPage">CCNA</Link>
<Link to="/EthicalPage">Ethical Hacking</Link>
<Link to="/LinuxPage">Linux</Link>
<Link to="/BasicCyberPage">Certificate in Cyber Security</Link>
<Link to="/AdvanceCyberPage">Advanced Cyber Security</Link>
                </div>
              </div>
            </div>

            <li><Link to="/GalleryPage">Gallery</Link></li>
            <li><Link to="/ContactFile">Contact Us</Link></li>
          </ul>
        </div>

       <div className='nav-right'>
        <ul>
                     <li><a href='https://www.instagram.com/csl_cybersecuritylearning/'><img src={img1} alt='' /></a></li>
          <li><a href='https://www.facebook.com/'><img src={img2} alt='' /></a></li>
          <li><a href='https://x.com/home?lang=en-in'><img src={img3} alt='' /></a></li>
         <li><a href='https://www.linkedin.com/in/cyber-security-learning-csl-896a8b3ba/?isSelfProfile=true'><img src={img6} alt='' /></a></li>
         <li><a href='https://www.google.com'><img src={img4} alt='' /></a></li>
          <li><a href='https://youtube.com/@csl_cybersecuritylearning?si=tdd0SR-4MLTbh69r'><img src={img5} alt='' /></a></li>        
           </ul>
                 </div>

        <div className='nav-menu' onClick={() => setMenuOpen(true)}>
          <img src={menu} alt='' />
        </div>
      </div>

      {/* Overlay */}
      {menuOpen && <div className="overlay" onClick={handleCloseMenu}></div>}

      {/* Sidebar */}
      <div className={`mobile-menu ${menuOpen ? "open" : ""}`}>

        <div className="menu-header">
          <h2>Menu</h2>
          <span onClick={handleCloseMenu}>✕</span>
        </div>

        <ul className="menu-links">

          <li>
            <Link to="/AboutPage" onClick={handleCloseMenu}>About Us</Link>
          </li>

          <li className="course-item">
            <div className="course-title" onClick={() => setCourseOpen(!courseOpen)}>
              <Link to="/CoursesFile" onClick={handleCloseMenu}>Courses</Link>
              <span>{courseOpen ? "▲" : "▼"}</span>
            </div>

            {courseOpen && (
              <div className="course-dropdown">
                <Link to="/CiscoPage" onClick={handleCloseMenu}>Cisco Certificate</Link>
                <Link to="/CCNAPage" onClick={handleCloseMenu}>CCNA</Link>
                <Link to="/EthicalPage" onClick={handleCloseMenu}>Ethical Hacking</Link>
                <Link to="/LinuxPage" onClick={handleCloseMenu}>Linux</Link>
                <Link to="/BasicCyberPage" onClick={handleCloseMenu}>Certificate in Cyber Security</Link>
                <Link to="/AdvanceCyberPage" onClick={handleCloseMenu}>Advanced Cyber Security</Link>
              </div>
            )}
          </li>

          <li>
            <Link to="/GalleryPage" onClick={handleCloseMenu}>Gallery</Link>
          </li>

          <li>
            <Link to="/ContactFile" onClick={handleCloseMenu}>Contact Us</Link>
          </li>

        </ul>

         {/* Social Icons */}
        <div className="menu-social">
           <a href='https://www.instagram.com/csl_cybersecuritylearning/'><img src={img1} alt='' /></a>
          <a href='https://www.facebook.com/'><img src={img2} alt='' /></a>
          <a href='https://x.com/home?lang=en-in'><img src={img3} alt='' /></a>
          <a href='https://www.linkedin.com/in/cyber-security-learning-csl-896a8b3ba/?isSelfProfile=true'><img src={img6} alt='' /></a>
          <a href='https://www.google.com'><img src={img4} alt='' /></a>
          <a href='https://youtube.com/@csl_cybersecuritylearning?si=tdd0SR-4MLTbh69r'><img src={img5} alt='' /></a>
        </div>
      </div>
    </>
  );
};

export default Navbar;